import { Routes, Route, Navigate } from "react-router-dom";
import UserLayout from "../layouts/user-layouts/UserLayout";
import Home from "../pages/user-pages/main-page/Home";
import PrivateRoutes from "./PrivateRoutes";
import AdminLayout from "../layouts/admin-layouts/AdminLayout";
import Dashboard from "../pages/admin-pages/dashboard-page/Dashboard";
import Auth from "../pages/admin-pages/auth/Auth";

function AppRoutes() {
  return (
    <Routes>
      {/* Home Page at Root */}
      <Route
        path="/"
        element={
          <UserLayout>
            <Home />
          </UserLayout>
        }
      />

      {/* Redirect /user to root */}
      <Route path="/user" element={<Navigate to="/" replace />} />

      {/* ADMIN LOGIN */}
      <Route path="/admin/login" element={<Auth />} />

      {/* ADMIN DASHBOARD */}
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoutes>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </PrivateRoutes>
        }
      />
    </Routes>
  );
}

export default AppRoutes;
